// extracted by mini-css-extract-plugin
export var circle = "_88-1";
export var exitConfirmationModal = "_88-5";
export var iframe = "_88-0";
export var offline = "_88-3";
export var online = "_88-2";
export var workstationSelectError = "_88-4";